import $ from 'jquery';
import config from './../../../config';

export function save_user( data ){
	return dispatch => {
		$.ajax({
			method: 'POST',
			url: config.apiurl + 'userprofile/',
      data: data
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_USER",
				register: response
			})

		})

	}
}



// WEBPACK FOOTER //
// ./src/pages/register/actions/register.action.js